/* Back a Cap: Första omgången (nedräkning, nästa steg, kompakt köpruta). Byggd av backacap/forsta-omgangen/tema/bygg.py, redigera inte för hand. */
/* Första omgången: den gemensamma klockan. Alla varianter läser tiden härifrån, ingen räknar själv.
   EN inställning styr allt: BAC_OMGANG.stopp. George flyttar datumet där (i temat blir det en temainställning).

   window.BACOmgang.lage()  -> { ms, d, h, m, s, sista, stangd, stoppDag, stoppKort, stoppTid, leverans, efter, namn }
       ms      millisekunder kvar (0 när det är stängt)
       d h m s hela dagar, timmar, minuter, sekunder kvar
       sista   true under sista dygnet
       stangd  true när stoppet har passerat
       stoppDag  "söndag 18 oktober", stoppKort "sön 18 okt", stoppTid "23.59"
       storlekTill "30 november" så länge storleken kan ändras gratis, annars "" (gäller oberoende av om omgången är öppen)
   window.BACOmgang.pa(fn)  -> fn(lage) körs direkt och sedan varje sekund
   window.BACOmgang.kund()  -> { fornamn, efternamn } ur studions fält eller adressen ("" om okänt)
   window.BACOmgang.tva(n)  -> "07"
   window.BACOmgang.steg()  -> kundens nästa steg, se längre ner. window.BACOmgang.paSteg(fn) -> fn(steg) direkt och vid varje ändring

   Prov utan att vänta: ?kvar=3d  ?kvar=36h  ?kvar=90m  ?kvar=45s  ?kvar=0 (stängt). Klockan går från det värdet.
   ?rulla=10 provar att stoppet flyttas fram tio dagar av sig självt när det passerat (tillsammans med ?kvar=0). */
(function () {
  'use strict';
  var K = window.BAC_OMGANG = Object.assign({
    stopp: '2026-10-16 23:59',           // svensk tid. George 6 okt kväll: tio dagar (6 okt + 10 = fredag 16 okt). Flyttas här.
    rulla: 10,                           // PÅ sedan 6 okt 21.00 (George: "Slå på den"). Ett passerat stopp flyttas fram så här många dagar av sig självt. 0 = flyttas för hand.
    namn: 'Första omgången',
    leverans: 'januari',
    efter: 'senast 31 mars',
    storlekTill: ''                      // AVSTÄNGT. George 6 okt 20.30: "skippa det, kommer bara bli krångligt för oss". (Var '2026-11-30'. Tom text = löftet om storleksbyte visas ingenstans.)
  }, window.BAC_OMGANG || {});

  var q = new URLSearchParams(location.search);
  var PROV = q.get('foprov') === '1';   // provlägen gäller bara med ?foprov=1
  if (PROV && q.get('rulla')) K.rulla = +q.get('rulla') || 0;
  var TZ = 'Europe/Stockholm';
  /* Klockslag i svensk tid. Räknar i väggklocka så att 23.59 förblir 23.59 över bytet mellan sommar- och vintertid. */
  function vagg(ms) {
    var o = {}; new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      .formatToParts(new Date(ms)).forEach(function (d) { o[d.type] = +d.value; });
    return Date.UTC(o.year, o.month - 1, o.day, o.hour % 24, o.minute, o.second);
  }
  function franVagg(mal) { var t = mal; for (var i = 0; i < 3; i++) t += mal - vagg(t); return t; }
  function plusDagar(ms, n) { return franVagg(vagg(ms) + n * 864e5); }
  function tolka(txt) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(txt).trim());
    return m ? franVagg(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0)) : new Date(txt).getTime();
  }
  var stopp = tolka(K.stopp);
  /* Med rulla > 0 flyttas ett passerat stopp fram i hela steg tills det ligger i framtiden. */
  function rullaFram(nu0) { var n = +K.rulla || 0, varv = 0; if (n > 0) while (stopp <= nu0 && varv++ < 400) stopp = plusDagar(stopp, n); }
  rullaFram(Date.now());
  var kv = PROV ? q.get('kvar') : null;
  var forskjut = 0;
  if (kv !== null && kv !== '') {
    var m = /^(\d+(?:[.,]\d+)?)([dhms]?)$/.exec(String(kv).trim());
    if (m) { var tal = parseFloat(m[1].replace(',', '.')); var enh = { d: 864e5, h: 36e5, m: 6e4, s: 1e3 }[m[2] || 's']; forskjut = (stopp - tal * enh) - Date.now(); }
  }
  function nu() { return Date.now() + forskjut; }

  function del(opt) { return new Intl.DateTimeFormat('sv-SE', Object.assign({ timeZone: TZ }, opt)).format(new Date(stopp)); }
  var stoppDag, stoppKort, stoppTid;
  function datumtexter() {
    stoppDag = del({ weekday: 'long' }) + ' ' + del({ day: 'numeric' }) + ' ' + del({ month: 'long' });
    stoppKort = del({ weekday: 'short' }).replace('.', '') + ' ' + del({ day: 'numeric' }) + ' ' + del({ month: 'short' }).replace('.', '');
    stoppTid = del({ hour: '2-digit', minute: '2-digit', hour12: false }).replace(':', '.');
  }
  datumtexter();

  function tva(n) { return (n < 10 ? '0' : '') + n; }
  /* "30 november" så länge löftet om storleksbyte gäller, annars "". */
  function storlekTill() {
    if (!K.storlekTill) return '';
    var slut = new Date(K.storlekTill + 'T23:59:59+01:00').getTime(); if (!(slut > nu())) return '';
    var f = function (opt) { return new Intl.DateTimeFormat('sv-SE', Object.assign({ timeZone: TZ }, opt)).format(new Date(slut)); };
    return f({ day: 'numeric' }) + ' ' + f({ month: 'long' });
  }
  function lage() {
    if ((+K.rulla || 0) > 0 && stopp - nu() <= 0) { rullaFram(nu()); datumtexter(); }
    var ms = Math.max(0, stopp - nu()), t = Math.floor(ms / 1000);
    return { ms: ms, d: Math.floor(t / 86400), h: Math.floor(t % 86400 / 3600), m: Math.floor(t % 3600 / 60), s: t % 60,
      sista: ms > 0 && ms <= 864e5, stangd: ms <= 0, stoppDag: stoppDag, stoppKort: stoppKort, stoppTid: stoppTid,
      leverans: K.leverans, efter: K.efter, namn: K.namn, storlekTill: storlekTill() };
  }
  var lyssnare = [];
  function pa(fn) { lyssnare.push(fn); try { fn(lage()); } catch (e) {} }
  function slag() { var l = lage(); for (var i = 0; i < lyssnare.length; i++) { try { lyssnare[i](l); } catch (e) {} } }
  (function takt() { slag(); setTimeout(takt, 1000 - (nu() % 1000) + 5); })();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) slag(); });

  function kund() {
    var f = document.getElementById('f-fornamn'), e = document.getElementById('f-efternamn');
    var fn = (f && f.value || q.get('fornamn') || '').trim(), en = (e && e.value || q.get('efternamn') || '').trim();
    return { fornamn: fn, efternamn: en };
  }
  /* Nästa steg för kunden. Läses ur studions egen knapptext (#kopT), som är sanningen om läget.
     steg() -> { nasta: 'namn'|'fornamn'|'efternamn'|'storlek'|'text'|'kryss'|'klar'|'ovrigt', rad: 'text att visa' (kan vara tom), klara: 0..4, av: 4, knapp: studions knapptext }
     Stegen som räknas: namn, kokard, tråd, storlek. Kokard och tråd har alltid ett val, så den som kommer med sitt namn har redan 3 av 4. */
  var STEG = [
    [/^Skriv ditt namn/, 'namn', 'Börja här: skriv ditt namn'],
    [/^Skriv ditt förnamn/, 'fornamn', 'Skriv ditt förnamn'],
    [/^Skriv ditt efternamn/, 'efternamn', 'Skriv ditt efternamn också'],
    [/^Välj storlek/, 'storlek', 'Nästan klar. Bara storleken kvar.'],
    [/^Förkorta texten/, 'text', 'Texten är för lång för mössan'],
    [/^Bekräfta/, 'kryss', 'Sista steget: kryssa att allt stämmer'],
    [/^Lägg i varukorgen/, 'klar', 'Klar att sys. Hemma i {leverans}.']
  ];
  function steg() {
    var t = document.getElementById('kopT'), txt = t ? (t.textContent || '').trim() : '';
    var k = kund(), strl = !!document.querySelector('#strl input:checked');
    var klara = (k.fornamn && k.efternamn ? 1 : 0) + 2 + (strl ? 1 : 0), stangd = lage().stangd;
    for (var i = 0; i < STEG.length; i++) if (STEG[i][0].test(txt)) {
      var rad = STEG[i][2]; if (STEG[i][1] === 'klar') rad = stangd ? 'Klar att sys.' : rad.replace('{leverans}', K.leverans);
      /* Studion har inte hunnit läsa in namnet än (första ögonblicket efter laddning): visa ingenting hellre än fel uppmaning. */
      if (STEG[i][1] === 'namn' && k.fornamn && k.efternamn) return { nasta: 'ovrigt', rad: '', klara: klara, av: 4, knapp: txt };
      return { nasta: STEG[i][1], rad: rad, klara: klara, av: 4, knapp: txt };
    }
    return { nasta: 'ovrigt', rad: '', klara: klara, av: 4, knapp: txt };
  }
  var stegLyss = [], stegIgang = false, senast = null;
  function stegSlag() {
    var st = steg(), nyckel = st.nasta + '|' + st.klara + '|' + st.rad; if (nyckel === senast) return; senast = nyckel;
    for (var i = 0; i < stegLyss.length; i++) { try { stegLyss[i](st); } catch (e) {} }
  }
  /* paSteg(fn) -> fn(steg) körs direkt och varje gång läget ändras */
  function paSteg(fn) {
    var forst = steg(); stegLyss.push(fn); try { fn(forst); } catch (e) {}
    if (stegIgang) return; stegIgang = true; senast = forst.nasta + '|' + forst.klara + '|' + forst.rad;
    var t = document.getElementById('kopT');
    if (t && window.MutationObserver) new MutationObserver(stegSlag).observe(t, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', stegSlag, true); document.addEventListener('input', stegSlag, true);
    pa(function () { stegSlag(); });
  }
  window.BACOmgang = { lage: lage, pa: pa, kund: kund, tva: tva, steg: steg, paSteg: paSteg, installning: K };
})();

/* Första omgången: gemensam hjälp vid valen. Laddas av omgang.js, samma i alla varianter.
   1. Vid storleken: löftet att storleken kan ändras gratis (datumet ur BACOmgang.lage().storlekTill).
   2. Vid kokard och tråd: vilket val som är vanligast (sant enligt orderdatan: Saphir och guld). Inga tal. */
(function () {
  'use strict';
  if (!window.BACOmgang || document.querySelector('[data-fo-hjalp]')) return;
  function rad(klass, nyckel, html) { var p = document.createElement('p'); p.className = 'fo-hjalp' + (klass ? ' ' + klass : ''); p.setAttribute('data-fo-hjalp', nyckel); p.innerHTML = html; return p; }

  var strl = document.getElementById('blok-strl'), fel = document.getElementById('e-strl');
  if (strl && fel) {
    var s = rad('fo-hjalp--strl', 'strl', '<b>Osäker på storleken?</b> Välj den du tror på. Du kan ändra storlek gratis till <span data-fo-hjalp-datum></span>.');
    fel.parentNode.insertBefore(s, fel.nextSibling);
    window.BACOmgang.pa(function (l) { if (s.hidden !== !l.storlekTill) s.hidden = !l.storlekTill; var d = s.querySelector('[data-fo-hjalp-datum]'); if (d.textContent !== l.storlekTill) d.textContent = l.storlekTill; });
  }
  var kok = document.querySelector('#blok-kok .koknamn');
  if (kok) kok.parentNode.insertBefore(rad('', 'kok', 'Svårt att välja? Saphir är vanligast.'), kok.nextSibling);
  var trad = document.querySelector('#blok-trad .trad');
  if (trad) trad.parentNode.insertBefore(rad('', 'trad', 'Guld är vanligast.'), trad.nextSibling);
})();

/* Första omgången, slutlig variant. Grunden är "traden" (kortast och tydligast enligt domen 6 okt 2026),
   med de delar domaren pekade ut ur de andra två:
   ur "valet": stegen i fyra delar och raden "Beställ inom …, hemma i januari" i den fasta köpraden, nästa steg ovanför kryssrutan på dator, "Alla tillval ingår" vid priset
   ur "lappen": namnet i enfärgat mörkt guld (dator), sista dygnets mening i toppraden
   Guldtråden med nål är borta (den sålde inget). Löftet heter "Hemma i januari" överallt.
   Allt om tid kommer ur window.BACOmgang.pa(), kundens nästa steg ur paSteg(). Ingen egen klocka, inga datum i koden.
   Studions element flyttas inte och deras text rörs inte. */
(function () {
  'use strict';
  var O = window.BACOmgang, D = document, R = D.documentElement;
  if (!O || typeof O.pa !== 'function' || window.foSlutligIgang) return;
  window.foSlutligIgang = true;

  function ny(tag, klass, text) { var e = D.createElement(tag); if (klass) e.className = klass; if (text != null) e.textContent = text; return e; }
  function satt(e, text) { if (e && e.textContent !== text) e.textContent = text; }
  function visa(e, pa) { if (e && e.hidden === pa) e.hidden = !pa; }
  function del(namn, klass) {
    var gammal = D.querySelector('[data-fo="' + namn + '"]');
    if (gammal && gammal.parentNode) gammal.parentNode.removeChild(gammal);
    var e = ny('div', klass); e.setAttribute('data-fo', namn); return e;
  }
  /* En rad med tickande siffror: det synliga är dolt för skärmläsare, bredvid står en stilla text. */
  function rad(klass) {
    var p = ny('p', klass || 'fo-rad'), syn = ny('span', 'fo-syn');
    syn.setAttribute('aria-hidden', 'true');
    var o = { p: p, syn: syn, f: ny('span', 'fo-f'), t: ny('b', 'fo-tid'), e: ny('span', 'fo-e'), sr: ny('span', 'fo-sr') };
    syn.appendChild(o.f); syn.appendChild(o.t); syn.appendChild(o.e);
    p.appendChild(syn); p.appendChild(o.sr);
    return o;
  }
  /* Sidans Inter saknar tabellsiffror. Siffrorna som tickar (allt efter det första talet) får därför var sin ruta med fast bredd,
     så att inget flyttar sig. Det första talet (dagar, eller timmar sista dygnet) byts sällan och skrivs som vanlig text, utan luft omkring. */
  function tick(e, text) {
    if (!e || e.getAttribute('data-fo-t') === text) return;
    e.setAttribute('data-fo-t', text);
    while (e.firstChild) e.removeChild(e.firstChild);
    var m = /^(\d+)([\s\S]*)$/.exec(text), bit = m ? m[1] : '', rest = m ? m[2] : text;
    for (var i = 0; i < rest.length; i++) {
      var c = rest.charAt(i);
      if (c >= '0' && c <= '9') { if (bit) { e.appendChild(D.createTextNode(bit)); bit = ''; } e.appendChild(ny('i', 'fo-z', c)); }
      else bit += c;
    }
    if (bit) e.appendChild(D.createTextNode(bit));
  }
  function skriv(o, fore, tid, efter, las) { if (!o) return; satt(o.f, fore); tick(o.t, tid); satt(o.e, efter); satt(o.sr, las); }

  var band = null, kopf = null, led = null, nu = null, nu2 = null, ruta = null, start = null, trygg = null;

  /* Utan kryssruta (Georges förslag 6 okt): steget "Jag har kontrollerat brodyr och storlek" är borta, namnet får i stället en rad under sig.
     ?kryss=1 i adressen visar läget med kryssrutan kvar, för jämförelse.
     I demon ser studion rutan som alltid ikryssad. I temat tas kravet bort i studions egen kod. */
  var utanKryss = !/[?&]kryss=1/.test(location.search);
  try {
    var okRuta = D.getElementById('ok'), namnRad = D.getElementById('korrNamn');
    if (utanKryss && okRuta && namnRad) {
      R.classList.add('fo-utankryss');
      Object.defineProperty(okRuta, 'checked', { configurable: true, get: function () { return true; }, set: function () {} });
      okRuta.dispatchEvent(new Event('change', { bubbles: true }));
      if (!D.querySelector('.fo-koll')) namnRad.parentNode.insertBefore(ny('p', 'fo-koll', 'Kontrollera stavningen. Mössan sys precis så här.'), namnRad.nextSibling);
    }
  } catch (fel) {}

  try {
    /* A. Toppraden: en mening och nedräkningen */
    var bar = D.querySelector('.announcement-bar');
    var topp = bar && ((bar.closest && bar.closest('.topbar')) || bar.parentNode);
    if (topp) { var b = del('band', 'fo-band'); band = rad(); b.appendChild(band.p); topp.appendChild(b); }

    /* B. Fasta köpraden (under 1080 px): stegen i fyra delar, kundens nästa steg, sedan nedräkningen.
       Stegen och nästa steg hör till köpet och står kvar även när omgången är stängd. Bara nedräkningen (data-fo="kopftid") hör till omgången. */
    var kf = D.getElementById('kopf'), km = D.getElementById('kopM');
    if (kf && km && km.parentNode === kf) {
      var k = del('kopf', 'fo-kopf');
      led = ny('span', 'fo-led'); led.setAttribute('aria-hidden', 'true');
      for (var n = 0; n < 4; n++) led.appendChild(ny('i', 'fo-led__del'));
      nu = ny('p', 'fo-nu'); nu.setAttribute('data-fo', 'steg'); nu.hidden = true;
      kopf = rad(); kopf.p.setAttribute('data-fo', 'kopftid');
      k.appendChild(led); k.appendChild(nu); k.appendChild(kopf.p);
      kf.insertBefore(k, km);
    }

    /* C. Köprutan: löftet med nedräkningen och stoppet med jämförelsen, direkt ovanför kryss och knapp */
    var korr = D.getElementById('korr'), krys = D.getElementById('krys');
    if (korr && krys && korr.contains(krys)) {
      /* Nästa steg på dator, där den fasta köpraden inte finns. Står ovanför enheten. */
      var g2 = korr.querySelector('.fo-nu2'); if (g2 && g2.parentNode) g2.parentNode.removeChild(g2);
      nu2 = ny('p', 'fo-nu2'); nu2.hidden = true; krys.parentNode.insertBefore(nu2, krys);
      /* Löftet och köpknappen är EN enhet, i samma form som namnfältet och knappen på startsidan (bac-hero.css .h__order):
         ljus överdel med leveransen till vänster och tiden som är kvar till höger, guldlist, svart knapp.
         Förra läget (tre textrader ovanför en fristående knapp) ligger i arkiv/slutlig-2026-10-06-fore-enhet/. */
      var r = del('ruta', 'fo-ruta'), celler = ny('div', 'fo-celler'); celler.setAttribute('aria-hidden', 'true');
      var cell = function (klass) {
        var c = ny('div', 'fo-cell' + (klass ? ' ' + klass : '')), o = { et: ny('small', 'fo-et'), v: ny('b', 'fo-varde'), sub: ny('span', 'fo-sub') };
        c.appendChild(o.et); c.appendChild(o.v); c.appendChild(o.sub); celler.appendChild(c); return o;
      };
      ruta = { a: cell(''), b: cell('fo-cell--tid'), sr: ny('span', 'fo-sr') };
      ruta.b.v.className += ' fo-tid';
      r.appendChild(celler); r.appendChild(ruta.sr);
      var gp = korr.querySelector('.fo-pas'); if (gp && gp.parentNode) gp.parentNode.removeChild(gp);
      var pas = ny('i', 'fo-pas'); pas.setAttribute('aria-hidden', 'true');
      krys.parentNode.insertBefore(r, krys); krys.parentNode.insertBefore(pas, krys);
      /* "Alla tillval ingår" vid priset (syns på dator, där den ryms) */
      var tot = korr.querySelector('.tot');
      if (tot && !tot.querySelector('.fo-ingar')) tot.appendChild(ny('small', 'fo-ingar', 'Alla tillval ingår'));
    }
    /* Under köpknappen: löftet om storleksbyte. Hör inte till omgången, står kvar när den är stängd.
       (Betyget under knappen och delalänken togs bort 6 okt efter Georges ord: "kladdigt", "känns som alibaba". Före: arkiv/slutlig-2026-10-06-fore-luft/) */
    var ek = D.getElementById('e-kop');
    if (korr && ek && korr.contains(ek)) {
      var gamla = korr.querySelectorAll('.fo-trygg,.fo-betyg');
      for (var g = 0; g < gamla.length; g++) gamla[g].parentNode.removeChild(gamla[g]);
      trygg = ny('p', 'fo-trygg'); trygg.hidden = true;
      ek.parentNode.insertBefore(trygg, ek.nextSibling);
    }

    /* D. Startsidan: en rad ovanför beställningsrutan, utan att flytta något */
    var hk = D.getElementById('heroKnapp');
    var order = hk && ((hk.closest && hk.closest('.h__order')) || hk), nere = order && order.parentNode;
    if (nere) {
      var s = del('start', 'fo-start'), sp = ny('p', 'fo-rad');
      start = { f: ny('span', 'fo-f'), mal: ny('span', 'fo-mal') };
      sp.appendChild(start.f); sp.appendChild(start.mal); s.appendChild(sp);
      nere.insertBefore(s, order);
    }
  } catch (fel) {}

  var nasta = '', igang = false;
  function rita(l) {
    var pa = !l.stangd, sista = pa && !!l.sista, c = R.classList;
    c.toggle('fo-stangd', !pa); c.toggle('fo-sista', sista); c.toggle('fo-oppen', pa && !sista); c.toggle('fo-pa', pa);
    if (trygg) { var till = l.storlekTill || ''; satt(trygg, till ? 'Ändra storlek gratis till ' + till : ''); visa(trygg, !!till); }
    if (!pa) return;

    var tva = O.tva, lev = l.leverans, nar = l.stoppKort + ' ' + l.stoppTid, klar = nasta === 'klar';
    var tid = sista ? (l.d * 24 + l.h) + ' tim ' + tva(l.m) + ' min ' + tva(l.s) + ' s' : l.d + ' d ' + tva(l.h) + ' tim ' + tva(l.m) + ' min';
    var las = (sista ? 'Sista dygnet. ' : '') + 'Hemma i ' + lev + ' om du beställer senast ' + l.stoppDag + ' ' + l.stoppTid + '.';

    if (sista) skriv(band, 'Sista dygnet: hemma i ' + lev + '. ', tid, ' kvar', las);
    else skriv(band, 'Hemma i ' + lev + '. Beställ inom ', tid, '', las);

    /* Köpraden: säg vinsten så länge något val saknas. När allt är valt har raden ovanför ("Klar att sys. Hemma i januari.") redan sagt den. */
    if (kopf) {
      if (sista) { if (klar) skriv(kopf, 'Sista dygnet. Stänger om ', tid, '', las); else skriv(kopf, 'Sista dygnet: ', tid, ', hemma i ' + lev, las); }
      else if (klar) skriv(kopf, l.namn + ' stänger om ', tid, '', las);
      else skriv(kopf, 'Beställ inom ', tid, ', hemma i ' + lev, las);
    }
    if (ruta) {
      /* Bara januari. "annars senast 31 mars" togs bort 6 okt: George: "den förvirrar, först januari, sen mars? låt bara januari vara". */
      satt(ruta.a.et, 'Leverans'); satt(ruta.a.v, 'Hemma i ' + lev); satt(ruta.a.sub, '');
      satt(ruta.b.et, sista ? 'Sista dygnet' : 'Beställ inom'); tick(ruta.b.v, tid); satt(ruta.b.sub, 'senast ' + nar);
      satt(ruta.sr, las);
    }
    if (start) {
      satt(start.f, sista ? 'Sista dygnet. Stänger ' + l.stoppTid + '. ' : 'Beställ senast ' + nar + '. ');
      satt(start.mal, 'Hemma i ' + lev + '.');
    }
  }

  /* Kundens nästa steg: texten kommer ordagrant ur BACOmgang.paSteg(). */
  if (typeof O.paSteg === 'function') {
    try {
      O.paSteg(function (st) {
        var text = (st && st.rad) || '';
        nasta = (st && st.nasta) || '';
        if (nu) { satt(nu, text); nu.hidden = !text; }
        if (led) led.setAttribute('data-klara', String(Math.max(0, Math.min(4, (st && st.klara) || 0))));
        /* Dator: bara när något återstår. När allt är klart talar knappen själv. */
        if (nu2) { var t2 = nasta === 'klar' || nasta === 'ovrigt' ? '' : text; satt(nu2, t2); visa(nu2, !!t2); }
        var kl = D.querySelector('.fo-koll'); if (kl) { var kd = O.kund(); visa(kl, !!(kd.fornamn && kd.efternamn)); }
        if (igang && typeof O.lage === 'function') rita(O.lage());
      });
    } catch (fel) {}
  }
  O.pa(rita);
  igang = true;
})();
